import { createSelector } from 'reselect';
import { formValueSelector } from 'redux-form';
import legalContractResources from '../legalContractResources';
import keyfobFormResources from './keyfobFormResources';

const formSelector = formValueSelector(legalContractResources.formNameLegalContract, state => state.form.toJS());
const getIsEmpty = state => !formSelector(state, keyfobFormResources.facilityMemberID);

export default createSelector([getIsEmpty], isEmpty => ({ isEmpty }));